import React, { useImperativeHandle, useState } from 'react';
import { connect } from 'react-redux';

import { useI18n } from '../../../../../i18n';
import { cx } from '../../../../api';
import Form from '../../../general/form/Form';
import { actions } from '../../../../redux/api/reports';
import { localStorage as storage } from 'core/app/storage';
import DummyControl from 'core/react/general/form/DummyControl';
import GroupingPicker from 'core/react/share/categories/GroupingPicker';

const BATCH_SIZE = 70;

/**
 * @param {Object} props
 * @param {React.RefObject} props.customRef
 * @param {Object} props.timeRange
 * @param {boolean} [props.disabled]
 */

function Idling(props) {
	const { f } = useI18n();

	const [isAssetTypes, setIsAssetTypes] = useState(false);
	const [isGrouping, setGrouping] = useState(false);
	const [groupingId, setGroupingId] = useState(storage.get('groupingId'));

	useImperativeHandle(props.customRef, () => ({
		submit: (values) => {
			const parameters = new cx.ods.reports.IdlingReportParameters();
			parameters.timeRange = props.timeRange;
			parameters.timeRange.retrospective = values.retrospective;
			parameters.timeRange.window = new cx.ods.TimeWindow(BATCH_SIZE);
			parameters.minPeriod = values.minPeriod;
			parameters.maxSpeed = values.maxSpeed;
			parameters.groupingId = isGrouping ? groupingId : null;
			parameters.isAssetTypes = isAssetTypes;

			props.dispatch(actions.idling.request({ uri: values.uri, parameters, clear: true }));
		},
		clear: () => {
			props.dispatch(actions.idling.exportClear());
		},
	}));

	return (
		<Form.ControlGroup key={50} disabled={props.disabled}>
			<Form.Control
				controlName="maxSpeed"
				controlType={Form.Control.Type.Input}
				controlValidator={(value) => {
					value = parseInt(value);
					return !(Number.isInteger(value) && value > 0) && f('please enter integer number above zero');
				}}
				label={f('maximum speed') + ', ' + f('units.km/h')}
				type="number"
				initialValue={props.state.parameters ? props.state.parameters.maxSpeed : 5}
			/>
			<Form.Control
				controlName="minPeriod"
				controlType={Form.Control.Type.Input}
				controlValidator={(value) => {
					value = parseInt(value);
					return !(Number.isInteger(value) && value > 0) && f('please enter integer number above zero');
				}}
				label={f('minimum period') + ', ' + f('units.min')}
				type="number"
				initialValue={props.state.parameters ? props.state.parameters.minPeriod : 5}
			/>
			<Form.Control
				controlType={Form.Control.Type.Checkbox}
				controlName="isGrouping"
				value={isGrouping}
				onChange={setGrouping}
				label={f('include device grouping')}
				disabled={props.disabled}
			/>
			<Form.Control controlType={DummyControl} controlName="grouping" value={groupingId} onChange={() => {}} hidden />
			<GroupingPicker
				disabled={props.disabled || !isGrouping}
				categoryId={groupingId}
				onChange={setGroupingId}
				cleanable={false}
			/>
			<Form.Control
				controlType={Form.Control.Type.Checkbox}
				controlName="isAssetTypes"
				value={isAssetTypes}
				onChange={setIsAssetTypes}
				label={f('include asset types')}
				disabled={props.disabled}
			/>
			<Form.Control
				controlName="retrospective"
				controlType={Form.Control.Type.Checkbox}
				label={f('report later items first')}
				initialValue={props.state.parameters ? props.state.parameters.timeRange.retrospective : false}
			/>
		</Form.ControlGroup>
	);
}

export default connect((state) => {
	return { state: state.reports.idling };
})(Idling);
